import lazySizes from "lazysizes";
import { nav } from "./components/nav";
import { initPlusGrid } from "./components/plus-grid";
import LocomotiveScroll from "locomotive-scroll";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { EffectCoverflow } from 'swiper';

gsap.registerPlugin(ScrollTrigger);

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;

function checkIfTouchDevice() {
  return (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  );
}

function init() {
  // Add a small delay to ensure DOM is ready
  setTimeout(() => {
    document.querySelectorAll("a").forEach((link) => {
      if (link.hostname !== window.location.hostname) {
        link.setAttribute("target", "_blank");
      }
    });
  }, 100);
}

// Create observers
const elementsToCheckSticky = document.querySelectorAll(
  ".js-element-to-check-sticky"
);

const observer = new IntersectionObserver(
  ([entry]) => {
    entry.target.classList.toggle("is-sticky", entry.intersectionRatio < 1);
  },
  { threshold: [1.0] }
);

// Observe each element individually
elementsToCheckSticky.forEach((element) => observer.observe(element));

// Create observers for top and bottom
  const observerTop = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const textColor = entry.target.dataset.textColor;
        const sections = Array.from(
          document.querySelectorAll(".js-page-section[data-text-color]")
        );
        const currentIndex = sections.indexOf(entry.target);

        // When section enters viewport from bottom
        if (entry.isIntersecting && entry.boundingClientRect.top <= 0) {
          entry.target.setAttribute("data-in-view", "true");
          document
            .querySelectorAll(".js-observe-top")
            .forEach((el) => el.setAttribute("data-text-color", textColor));

          // Add active state to header and nav items
          const sectionId = entry.target.id;
          const header = document.querySelector(".js-header");
          const navItems = document.querySelectorAll(".js-nav-item");
          let hasActiveNavItem = false;
          
          navItems.forEach((item) => {
            const link = item.querySelector('a');
            const href = link?.getAttribute("href");
            if (href === `#${sectionId}`) {
              item.classList.add("active");
              item.classList.remove("is-active");
              hasActiveNavItem = true;
            } else {
              item.classList.remove("active");
            }
          });

          // Only add has-active-nav if there's an active nav item
          if (header) {
            if (hasActiveNavItem) {
              header.classList.add("has-active-nav");
            } else {
              header.classList.remove("has-active-nav");
            }
          }
        }
        // When section exits viewport from top
        else if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          const nextSection = sections[currentIndex + 1];
          if (nextSection) {
            document
              .querySelectorAll(".js-observe-top")
              .forEach((el) =>
                el.setAttribute(
                  "data-text-color",
                  nextSection.dataset.textColor
                )
              );

            // Update active state for next section
            const nextSectionId = nextSection.id;
            const header = document.querySelector(".js-header");
            const navItems = document.querySelectorAll('.js-nav-item');
            let hasActiveNavItem = false;

            navItems.forEach(item => {
              const link = item.querySelector('a');
              const href = link?.getAttribute("href");
              if (href === `#${nextSectionId}`) {
                item.classList.add("active");
                item.classList.remove("is-active");
                hasActiveNavItem = true;
              } else {
                item.classList.remove("active");
              }
            });

            // Update header class based on whether there's an active nav item
            if (header) {
              if (hasActiveNavItem) {
                header.classList.add("has-active-nav");
              } else {
                header.classList.remove("has-active-nav");
              }
            }
          }
        }

        entry.target.setAttribute("data-in-view", entry.isIntersecting);
      });
    },
    {
      rootMargin: "-30px",
      threshold: [0, 1],
    }
  );


 const observerBottom = new IntersectionObserver(
   (entries) => {
     entries.forEach((entry) => {
       const textColor = entry.target.dataset.textColor;
       const sections = Array.from(
         document.querySelectorAll(".js-page-section[data-text-color]")
       );
       const currentIndex = sections.indexOf(entry.target);

       // When section enters viewport from top
       if (entry.isIntersecting && entry.boundingClientRect.top >= 0) {
         entry.target.setAttribute("data-in-view", "true");
         document
           .querySelectorAll(".js-observe-bottom")
           .forEach((el) => el.setAttribute("data-text-color", textColor));
       }
       // When section exits viewport from bottom
       else if (!entry.isIntersecting && entry.boundingClientRect.top > 0) {
         const previousSection = sections[currentIndex - 1];
         if (previousSection) {
           document
             .querySelectorAll(".js-observe-bottom")
             .forEach((el) =>
               el.setAttribute(
                 "data-text-color",
                 previousSection.dataset.textColor
               )
             );
         }
       }

       entry.target.setAttribute("data-in-view", entry.isIntersecting);
     });
   },
   {
     rootMargin: "0px 0px -30px 0px",
     threshold: [0, 1],
   }
 );

// Create a function to handle the scroll setup
function initSmoothScroll() {
  // Temporarily return null to disable LocomotiveScroll
  return null;

  /* Original code preserved but commented out for future use
  // Check if we should use smooth scrolling
  const isTouchDevice = (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  );
  const isMobile = window.innerWidth <= 768;

  // Don't initialize on touch devices or mobile
  if (isTouchDevice || isMobile) {
    // Set up ScrollTrigger for native scrolling
    ScrollTrigger.defaults({
      scroller: window
    });
    return null;
  }

  // Check if LocomotiveScroll exists and we have a scroll container
  if (typeof LocomotiveScroll === 'undefined' || !document.querySelector('[data-scroll-container]')) {
    console.warn('LocomotiveScroll is not loaded or no scroll container found.');
    return null;
  }

  // Initialize Locomotive Scroll
  const locoScroll = new LocomotiveScroll({
    el: document.querySelector("[data-scroll-container]"),
    smooth: true,
    multiplier: 1,
    lerp: 0.1,
    reloadOnContextChange: true,
    smartphone: {
      smooth: false,
    },
    tablet: {
      smooth: false,
    },
    smoothMobile: 0,
  });

  // Tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element
  ScrollTrigger.scrollerProxy("[data-scroll-container]", {
    scrollTop(value) {
      return arguments.length ? locoScroll.scrollTo(value, {duration: 0, disableLerp: true}) : locoScroll.scroll.instance.scroll.y;
    },
    getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
    },
    pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
  });

  // Reset scroll position on page load
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
  
  // Force scroll to top when page is refreshed
  if (locoScroll) {
    setTimeout(() => {
      locoScroll.scrollTo(0, { duration: 0, disableLerp: true });
      locoScroll.update();
    }, 50);
  }

  // Each time Locomotive Scroll updates, tell ScrollTrigger to update too
  locoScroll.on("scroll", ScrollTrigger.update);

  // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll
  ScrollTrigger.addEventListener("refresh", () => locoScroll.update());

  // Return the instance for later use
  return locoScroll;
  */
}

function getScrollerConfig() {
  // Always return window as scroller while LocomotiveScroll is disabled
  return {
    scroller: window,
    isMobile: true
  };
}

function initWordAnimations() {
  const text = document.querySelectorAll(".js-animate-text");
  if (text.length === 0) return;
  
  const { scroller, isMobile } = getScrollerConfig();
  
  text.forEach((element) => {
    // Create a temporary container to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = element.innerHTML;
    
    // Function to process text nodes and elements
    function processNode(node) {
      if (node.nodeType === 3) { // Text node
        const words = node.textContent.split(/\s+/);
        return words.map(word => {
          if (word.trim() === '') return ' ';
          return `<span class="word-to-animate">${word}</span>`;
        }).join(' ');
      } else if (node.nodeType === 1) { // Element node
        if (node.nodeName === 'BR') {
          return '<br>';
        } else {
          // Preserve the element but process its text content
          const clone = node.cloneNode(false);
          clone.innerHTML = Array.from(node.childNodes)
            .map(child => processNode(child))
            .join('');
          return clone.outerHTML;
        }
      }
      return '';
    }

    // Process all nodes and update innerHTML
    element.innerHTML = Array.from(tempDiv.childNodes)
      .map(node => processNode(node))
      .join('');

    // Animate each word
    let wordSpans = element.querySelectorAll('.word-to-animate');
    wordSpans.forEach((word, index) => {
      gsap.from(word, {
        scrollTrigger: {
          trigger: word,
          start: "top 90%",
          end: "top 60%",
          scrub: 0.5,
          toggleActions: "play none none reverse",
          scroller: scroller,
          markers: false
        },
        opacity: 0.25,
        y: 30,
        duration: 0.4,
        ease: "power2.out"
      });
    });
  });
}

function initPartnerAnimations() {
  const partnersSection = document.querySelector('.g-partners');
  if (!partnersSection) return;

  const { scroller, isMobile } = getScrollerConfig();

  const heading = partnersSection.previousElementSibling;
  if (heading) {
    gsap.to(heading, {
      scrollTrigger: {
        trigger: partnersSection,
        start: "top 30%",
        end: "bottom 10%",
        scrub: 0.8,
        scroller: scroller
      },
      y: (i, target) => {
        return -(partnersSection.offsetHeight * 0.1);
      },
      ease: "power1.inOut"
    });
  }

  const partners = partnersSection.querySelectorAll('svg');
  if (!partners.length) return;

  partners.forEach(partner => {
    gsap.set(partner, { opacity: 0 });
    
    const floatDuration = 2 + Math.random() * 3;
    const floatDistanceY = 5 + Math.random() * 20;
    const floatDistanceX = 5 + Math.random() * 15;
    
    gsap.to(partner, {
      y: Math.random() > 0.5 ? `+=${floatDistanceY}` : `-=${floatDistanceY}`,
      x: Math.random() > 0.5 ? `+=${floatDistanceX}` : `-=${floatDistanceX}`,
      duration: floatDuration,
      repeat: -1,
      yoyo: true,
      ease: Math.random() > 0.5 ? "sine.inOut" : "power1.inOut",
      delay: Math.random() * 2
    });
  });

  const delays = Array.from({length: partners.length}, () => Math.random() * 0.8);

  ScrollTrigger.create({
    trigger: partnersSection,
    start: "top 80%",
    scroller: scroller,
    onEnter: () => {
      partners.forEach((partner, i) => {
        gsap.to(partner, {
          opacity: 1,
          duration: 1.2,
          delay: delays[i],
          ease: "power2.out"
        });
      });
    },
    onLeaveBack: () => {
      partners.forEach(partner => {
        gsap.to(partner, {
          opacity: 0,
          duration: 0.3
        });
      });
    }
  });
}

function initDefaultFadeIn() {
  const fadeInSections = document.querySelectorAll('.js-fade-in-staggered');
  if (!fadeInSections.length) return;

  const { scroller, isMobile } = getScrollerConfig();

  fadeInSections.forEach(section => {
    const elements = section.children;
    if (!elements.length) return;

    gsap.set(elements, { opacity: 0, y: 40 });

    ScrollTrigger.create({
      trigger: section,
      start: "top 80%",
      scroller: scroller,
      onEnter: () => {
        gsap.to(elements, {
          opacity: 1,
          y: 0,
          duration: isMobile ? 0.8 : 1.2,
          stagger: {
            amount: isMobile ? 0.4 : 0.6,
            from: "start"
          },
          ease: "power3.out"
        });
      },
      onLeaveBack: () => {
        gsap.to(elements, {
          opacity: 0,
          y: 40,
          duration: 0.6,
          ease: "power2.in"
        });
      }
    });
  });
}

function initCardStaggerAnimation() {
  const cardContainers = document.querySelectorAll('.js-card-stagger');
  if (!cardContainers.length) return;

  const { scroller, isMobile } = getScrollerConfig();

  cardContainers.forEach(container => {
    const cards = Array.from(container.children);
    if (!cards.length) return;

    gsap.set(cards, {
      opacity: 0,
      y: 60,
      scale: 0.95
    });

    cards.forEach(card => {
      ScrollTrigger.create({
        trigger: card,
        start: "top 90%",
        scroller: scroller,
        onEnter: () => {
          gsap.to(card, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: isMobile ? 0.8 : 1,
            ease: "power3.out"
          });
        },
        onLeaveBack: () => {
          gsap.to(card, {
            opacity: 0,
            y: 60,
            scale: 0.95,
            duration: 0.5,
            ease: "power2.in"
          });
        }
      });
    });
  });
}


function initLogoAnimation() {
  const logo = document.querySelector('.js-logo-animate-on-scroll');
  if (!logo) return;

  gsap.set(logo, {
    scale: 1,
    x: 0,
    y: 0,
    transformOrigin: "center center"
  });

  ScrollTrigger.create({
    scroller: "[data-scroll-container]",
    start: 0,
    end: "1000px", 
    scrub: 1.5,
    onUpdate: (self) => {
      const progress = self.progress;
      const scale = gsap.utils.interpolate(1, 0.2, progress);
      
      gsap.to(logo, {
        scale: scale,
        duration: 0.8,
        ease: "power2.out",
        overwrite: true
      });
    }
  });
}

function initHeroParallax() {
  const heroText = document.querySelector('.c-home-hero__content');
  const heroLogo = document.querySelector('.c-home-hero .o-logo-container');
  if (!heroText || !heroLogo) return;

  const hero = document.querySelector('.c-home-hero');
  if (!hero) return;

  const { scroller, isMobile } = getScrollerConfig();

  ScrollTrigger.create({
    trigger: hero,
    start: "top top",
    end: "bottom top",
    scrub: true,
    scroller: scroller,
    onUpdate: (self) => {
      const progress = self.progress;
      const yOffset = progress * 100;

      gsap.to([heroText, heroLogo], {
        y: -yOffset,
        duration: 0.1,
        ease: "none",
        overwrite: true
      });
    }
  });
}

function initPushBlur() {
  const push = document.querySelector('.c-push');
  if (!push) return;

  const { scroller, isMobile } = getScrollerConfig();

  ScrollTrigger.create({
    trigger: push,
    start: "15% top",
    end: "bottom top",
    scrub: true,
    scroller: scroller,
    onUpdate: (self) => {
      const progress = self.progress;
      const blur = gsap.utils.interpolate(0, 50, progress);
      push.style.backdropFilter = `blur(${blur}px)`;
    }
  });
}

function initHeroVideoControl() {
  const heroVideo = document.querySelector('.js-hero-video-container video');
  if (!heroVideo) return;

  ScrollTrigger.create({
    trigger: '.c-push',
    start: 'top top',
    end: 'center top',
    scroller: "[data-scroll-container]",
    onUpdate: (self) => {
      if (self.progress >= 1) {
        heroVideo.pause();
      } else {
        if (heroVideo.paused) {
          heroVideo.play();
        }
      }
    }
  });
}

function initMediaScaleOnScroll() {
  const mediaContainers = document.querySelectorAll('.js-media-scale-on-scroll');
  const { scroller, isMobile } = getScrollerConfig();
  
  function updateMediaContainers() {
    if (window.innerWidth <= 640) {
      mediaContainers.forEach(container => {
        gsap.set(container, { scale: 1 });
      });
      return;
    }

    if (!mediaContainers.length) return;

    mediaContainers.forEach(container => {
      // Recalculate dimensions
      const aspectRatio = container.getAttribute('data-ratio') || 1.5;
      const finalHeight = window.innerWidth / aspectRatio;

      // Update wrapper height
      const wrapper = container.parentElement;
      if (wrapper) {
        wrapper.style.height = `${finalHeight}px`;
      }
    });
  }

  // Initial setup
  mediaContainers.forEach(container => {
    const maxScale = 1.05;
    const aspectRatio = container.getAttribute('data-ratio') || 1.5;
    const finalHeight = window.innerWidth / aspectRatio;

    // Create wrapper if it doesn't exist
    let wrapper = container.parentElement;
    if (!wrapper || !wrapper.classList.contains('media-scale-wrapper')) {
      wrapper = document.createElement('div');
      wrapper.classList.add('media-scale-wrapper');
      container.parentNode.insertBefore(wrapper, container);
      wrapper.appendChild(container);
    }
    wrapper.style.height = `${finalHeight}px`;

    // Set up ScrollTrigger animation
    ScrollTrigger.create({
      trigger: wrapper,
      start: "top center",
      end: "bottom top",
      scrub: 1.25,
      scroller: scroller,
      onUpdate: (self) => {
        const progress = self.progress;
        let scale;
        
        if (progress < 0.25) {
          scale = gsap.utils.interpolate(0.4, 1, progress * 4);
        } 
        else if (progress < 0.75) {
          scale = 1.05;
        }
        
        gsap.to(container, {
          scale: scale,
          duration: 0.4,
          ease: "power2.out",
          overwrite: true
        });
      }
    });
  });

  // Add resize handler
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateMediaContainers, 250);
  });
}

function initPlusGridOpacity() {
  const sections = document.querySelectorAll('.js-page-section');
  if (!sections.length) return;

  const { scroller, isMobile } = getScrollerConfig();

  sections.forEach(section => {
    const plusGrid = section.querySelector('.c-plus-grid');
    if (!plusGrid) return;

    gsap.set(plusGrid, { opacity: 0 });

    ScrollTrigger.create({
      trigger: section,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      scroller: scroller,
      onUpdate: (self) => {
        let opacity;
        if (self.progress <= 0.5) {
          opacity = gsap.utils.interpolate(0, 1, self.progress * 2);
        }
        else {
          opacity = gsap.utils.interpolate(1, 0, (self.progress - 0.5) * 2);
        }

        gsap.to(plusGrid, {
          opacity: opacity,
          duration: 0.4,
          ease: "power2.out",
          overwrite: true
        });
      }
    });
  });
}

function initInsightsAnimations() {
  const section = document.querySelector('#insights');
  const infographic = section?.querySelector('.c-insights-infographic');
  const content = section?.querySelector('.c-insights-content');
  
  if (!section || !infographic || !content) return;

  const { scroller, isMobile } = getScrollerConfig();

  gsap.set(infographic, {
    opacity: 1
  });
  
  gsap.set(content, {
    opacity: 1,
    filter: 'blur(0px)'
  });

  infographic.style.position = 'sticky';
  infographic.style.top = '0';

  ScrollTrigger.create({
    trigger: section,
    start: "top top",
    end: "bottom bottom",
    scrub: true,
    scroller: scroller,
    onUpdate: (self) => {
      const infographicOpacity = gsap.utils.interpolate(1, 0.2, self.progress);
      const contentOpacity = gsap.utils.interpolate(1, 0, Math.min(1, self.progress * 2));
      const contentBlur = gsap.utils.interpolate(0, 50, Math.min(1, self.progress * 2));
      
      gsap.to(infographic, {
        opacity: infographicOpacity,
        duration: 0.1,
        ease: "none",
        overwrite: true
      });

      gsap.to(content, {
        opacity: contentOpacity,
        filter: `blur(${contentBlur}px)`,
        duration: 0.2,
        ease: "none",
        overwrite: true
      });
    }
  });
}

function initCertificatesScroll() {
  const certificatesSection = document.querySelector('.js-certificates');
  if (!certificatesSection) return;

  const { scroller, isMobile } = getScrollerConfig();

  certificatesSection.style.display = 'flex';
  certificatesSection.style.flexWrap = 'nowrap';
  certificatesSection.style.width = 'max-content';
  certificatesSection.style.position = 'relative';
  
  const wrapper = document.createElement('div');
  wrapper.style.width = '100%';
  wrapper.style.overflow = 'hidden';
  wrapper.style.position = 'relative';
  certificatesSection.parentNode.insertBefore(wrapper, certificatesSection);
  wrapper.appendChild(certificatesSection);

  const certificates = certificatesSection.children;
  const certificatesArray = Array.from(certificates);
  
  for (let i = 0; i < 6; i++) {
    certificatesArray.forEach(cert => {
      const clone = cert.cloneNode(true);
      clone.classList.add('certificate-clone');
      clone.style.flexShrink = '0';
      certificatesSection.appendChild(clone);
    });
  }

  const totalWidth = certificatesSection.scrollWidth;
  
  const tl = gsap.timeline({
    repeat: -1,
    defaults: { ease: "none" }
  });

  tl.to(certificatesSection, {
    x: -totalWidth / 7,
    duration: 60, // Increased from 30 to 60 to make it 50% slower
    ease: "none",
    onComplete: () => {
      gsap.set(certificatesSection, { x: 0 });
    }
  });

  // Add hover zones with Locomotive Scroll compatibility
  const leftZone = document.createElement('div');
  const rightZone = document.createElement('div');

  [leftZone, rightZone].forEach(zone => {
    zone.style.position = 'absolute';
    zone.style.top = '0';
    zone.style.height = '100%';
    zone.style.width = '25%';
    zone.style.zIndex = '1';
  });

  leftZone.style.left = '0';
  rightZone.style.right = '0';

  wrapper.appendChild(leftZone);
  wrapper.appendChild(rightZone);

  let currentSpeed = 1;
  const normalSpeed = 1; // Reduced from 2 to 1 to make it 50% slower
  const hoverSpeed = 3.5; // Reduced from 7 to 3.5 to make it 50% slower

  leftZone.addEventListener('mouseenter', () => {
    gsap.to(tl, {
      timeScale: -hoverSpeed,
      duration: 0.3,
      ease: "power1.out"
    });
  });

  rightZone.addEventListener('mouseenter', () => {
    gsap.to(tl, {
      timeScale: hoverSpeed,
      duration: 0.3,
      ease: "power1.out"
    });
  });

  [leftZone, rightZone].forEach(zone => {
    zone.addEventListener('mouseleave', () => {
      gsap.to(tl, {
        timeScale: normalSpeed,
        duration: 0.3,
        ease: "power1.out"
      });
    });
  });

  ScrollTrigger.create({
    trigger: wrapper,
    start: "top bottom",
    end: "bottom top",
    scroller: scroller,
    onEnter: () => {
      tl.play();
    },
    onLeave: () => {
      tl.pause();
    },
    onEnterBack: () => {
      tl.play();
    },
    onLeaveBack: () => {
      tl.pause();
    }
  });
}

// Initialize testimonials carousel
function initTestimonialsCarousel() {
  const testimonialSection = document.querySelector('.js-testimonials');
  if (!testimonialSection) return;

  const testimonialSwiper = new Swiper('.js-testimonials', {
    modules: [EffectCoverflow],
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 30,
    loop: true,
    grabCursor: true,
    speed: 600,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 125,
      modifier: 2,
      scale: 0.95,
      slideShadows: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 10,
        effect: 'slide', // Use regular slide effect on mobile
        coverflowEffect: {
          enabled: false // Disable coverflow on mobile
        }
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 30,
        effect: 'coverflow', // Re-enable coverflow on desktop
        coverflowEffect: {
          enabled: true,
          depth: 125,
          modifier: 2,
          scale: 0.95,
          stretch: 0
        }
      }
    },
    on: {
      init: function() {
        updateTestimonialStyles(this);
        addSlideClickHandlers(this);
      },
      slideChange: function() {
        updateTestimonialStyles(this);
      }
    } 
  });

  function updateTestimonialStyles(swiper) {
    const slides = swiper.slides;
    const isMobile = window.innerWidth < 768;
    
    slides.forEach((slide, index) => {
      if (index === swiper.activeIndex) {
        slide.style.opacity = '1';
        slide.style.transform = 'scale(1)';
      } else {
        slide.style.opacity = isMobile ? '0.3' : '0.5'; // More fade on mobile
        slide.style.transform = isMobile ? 'scale(0.8)' : 'scale(0.85)';
      }
    });
  }

  function addSlideClickHandlers(swiper) {
    swiper.slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        if (index !== swiper.activeIndex) {
          swiper.slideTo(index);
        }
      });
    });
  }

}

function initAnimateNumbers() {
  const animateNumbers = document.querySelectorAll('.js-animate-numbers-number');
  if (!animateNumbers.length) return;

  const { scroller, isMobile } = getScrollerConfig();
  
  animateNumbers.forEach(numberElement => {
    const targetNumber = parseInt(numberElement.innerText);
    let currentNumber = 0;
    let startTime = null;
    const duration = isMobile ? 400 : 600; // Faster animation on mobile
    let isAnimating = false;
    
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      
      if (progress < duration) {
        currentNumber = Math.floor((progress / duration) * targetNumber);
        numberElement.innerText = currentNumber;
        requestAnimationFrame(animate);
      } else {
        numberElement.innerText = targetNumber;
        isAnimating = false;
      }
    };

    ScrollTrigger.create({
      trigger: numberElement,
      start: "top 80%",
      scroller: scroller,
      onEnter: () => {
        if (!isAnimating) {
          isAnimating = true;
          startTime = null;
          currentNumber = 0;
          requestAnimationFrame(animate);
        }
      }
    });
  });
}

function checks() {
  isTouchDevice = checkIfTouchDevice();
  if (isTouchDevice) {
    document.documentElement.classList.add("is-touch");
  }
  isHomepage = document.body.classList.contains("page-home");
}

// Initialize everything
document.addEventListener("DOMContentLoaded", () => {
  // Prevent scroll restoration
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);

  checks();
  init();

  // Add observers to elements
  document.querySelectorAll(".js-observe-top").forEach((element) => {
    observerTop.observe(element);
  });

  document.querySelectorAll(".js-observe-bottom").forEach((element) => {
    observerBottom.observe(element);
  });

  const sections = document.querySelectorAll(".js-page-section[data-text-color]");
  sections.forEach((section) => {
    observerBottom.observe(section);
    observerTop.observe(section);
  });

  // Update ScrollTrigger defaults
  ScrollTrigger.defaults({
    scroller: window
  });

  // Kill any existing ScrollTrigger instances
  ScrollTrigger.getAll().forEach(st => st.kill());

  // Initialize all animations
  initWordAnimations();
  initPlusGrid();
  initPartnerAnimations();
  initDefaultFadeIn();
  initCardStaggerAnimation();
  initHeroParallax();
  initPushBlur();
  initHeroVideoControl();
  initMediaScaleOnScroll();
  initPlusGridOpacity();
  initInsightsAnimations();
  initCertificatesScroll();
  initTestimonialsCarousel();
  initAnimateNumbers();

  // Refresh ScrollTrigger
  ScrollTrigger.refresh(true);

  // Handle window resize with debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      ScrollTrigger.refresh(true);
    }, 250);
  });

  nav(isNavToggled);
});

